module.exports = __webpack_public_path__ + "img/logo.029cb4b0.png";